"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDemandPlatformFeeConfig = exports.generateTieredFeeConfig = exports.generateSupplySubAccountFeeConfig = exports.generateFeeConfig = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
const api_models_1 = require("@portal/api-models");
faker_1.default.seed(718);
const generateFeeConfig = (configType) => {
    return {
        configType: configType !== null && configType !== void 0 ? configType : faker_1.default.helpers.arrayElement(Object.values(api_models_1.DemandPlatformFeeConfigType)),
        percent: faker_1.default.datatype.number({ max: 1.0, min: 0.01, precision: 0.0001 }),
    };
};
exports.generateFeeConfig = generateFeeConfig;
const generateSupplySubAccountFeeConfig = () => {
    const configType = api_models_1.DemandPlatformFeeConfigType.SupplySubAccount;
    const key1 = faker_1.default.unique(() => faker_1.default.datatype.number({ max: 100, min: 1 }).toString());
    const key2 = faker_1.default.unique(() => faker_1.default.datatype.number({ max: 100, min: 1 }).toString());
    return {
        configType,
        default: (0, exports.generateFeeConfig)(api_models_1.DemandPlatformFeeConfigType.PercentageOf),
        supplySubAccounts: {
            [key1]: (0, exports.generateFeeConfig)(api_models_1.DemandPlatformFeeConfigType.PercentageOf),
            [key2]: (0, exports.generateFeeConfig)(api_models_1.DemandPlatformFeeConfigType.PercentageOf),
        },
    };
};
exports.generateSupplySubAccountFeeConfig = generateSupplySubAccountFeeConfig;
const generateTieredFeeConfig = () => {
    const configType = api_models_1.DemandPlatformFeeConfigType.Tiered;
    const key1 = faker_1.default.unique(() => faker_1.default.datatype.number({ max: 1000, min: 1 }).toString());
    const key2 = faker_1.default.unique(() => faker_1.default.datatype.number({ max: 1000, min: 1 }).toString());
    return {
        configType,
        defaultTier: (0, exports.generateFeeConfig)(api_models_1.DemandPlatformFeeConfigType.PercentageOf),
        tiers: {
            [key1]: (0, exports.generateFeeConfig)(api_models_1.DemandPlatformFeeConfigType.PercentageOf),
            [key2]: (0, exports.generateFeeConfig)(api_models_1.DemandPlatformFeeConfigType.PercentageOf),
        },
    };
};
exports.generateTieredFeeConfig = generateTieredFeeConfig;
const generateDemandPlatformFeeConfig = (configType, isDemandReceivablesEnabled) => {
    const getDefaultPercentOf = (fallback = api_models_1.DemandPlatformFeeConfigPercentOf.NetworkPayout) => isDemandReceivablesEnabled
        ? api_models_1.DemandPlatformFeeConfigPercentOf.DemandReceivable
        : fallback;
    switch (configType) {
        case api_models_1.DemandPlatformFeeConfigType.SupplySubAccount:
            return {
                config: (0, exports.generateSupplySubAccountFeeConfig)(),
                percentOf: getDefaultPercentOf(),
            };
        case api_models_1.DemandPlatformFeeConfigType.Tiered:
            return {
                config: (0, exports.generateTieredFeeConfig)(),
                percentOf: getDefaultPercentOf(api_models_1.DemandPlatformFeeConfigPercentOf.FinancialProductMonetaryValue),
            };
        case api_models_1.DemandPlatformFeeConfigType.PercentageOf:
            return {
                config: {
                    configType: api_models_1.DemandPlatformFeeConfigType.PercentageOf,
                    percent: 0,
                },
                percentOf: getDefaultPercentOf(),
            };
        default:
            return {
                config: {
                    configType: api_models_1.DemandPlatformFeeConfigType.PercentageOf,
                    percent: 0,
                },
                percentOf: getDefaultPercentOf(),
            };
    }
};
exports.generateDemandPlatformFeeConfig = generateDemandPlatformFeeConfig;
